import Icons from 'assets/icons'
import Button from 'components/formElements/Button'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import moment from 'moment'
import {Calendar} from 'primereact/calendar'
import { PropTypes } from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { updateEdittedRow } from 'redux/features/projectDetail/projectDetailSlice'

const InvoiceInlineApprovalModalContent = ({ handleClose, approvalModal }) => {
	const [uploadFile] = useRequest()
	const [deleteFile] = useRequest()
	const { edittedRow } = useSelector((state) => state.projectDetail)
	const dispatch = useDispatch()
	const { showToast } = useToast()
	const validateSelectedFile = (file) => {
		const MAX_FILE_SIZE = 20480 // 20MB
		const fileSizeKiloBytes = file.size / 1024
		let errorMsg = ''
		if (fileSizeKiloBytes > MAX_FILE_SIZE) {
			errorMsg = "Dosya 20mb'dan küçük olmalıdır ";
		}
		return errorMsg
	};
	console.log(edittedRow,'edittedRow')
	const convert = async (fileList) => {
		let errorMessage = ''
		for (let i = 0; i < fileList.length; i++) {
			const file = fileList[i];
			if (validateSelectedFile(file) != '') {
				errorMessage = validateSelectedFile(file)
				break
			}
		}
		if (errorMessage == '') {
			for await (const file of fileList) {
				const formData = new FormData();
				formData.append("File", file);
				formData.append('InvoiceId', edittedRow.id)
				uploadFile('/Invoices/AddInvoiceDocuments', {
					method: 'POST',
					data: formData
				}).then(res => {
					if (res.data.ok) {
						dispatch(updateEdittedRow({ key: 'invoicesDocuments', value: [...edittedRow['invoicesDocuments'], { ...res.data.result }] }))
					} else {
						showToast(res.data.metadata.message, 'error')
					}
				})
			}
		} else {
			showToast(errorMessage, 'error')
		}
	};
	const handleApproved = () => {
		if (approvalModal.invoiceStatusId == 1) {
			dispatch(updateEdittedRow({ key: 'actualDate', value: moment().add(3, 'hours').toISOString() }))
			handleClose()
		}
		if (approvalModal.invoiceStatusId == 2) {
			if (!edittedRow.estimatedDate) {
				showToast('Kesilecek Ay/Yıl seçimini yapınız','error')
			}else {
				handleClose()
			}
		}
		if (approvalModal.invoiceStatusId == 7) {
			if (!edittedRow.description || !edittedRow.invoiceNo) {
				showToast('Fatura Numarası ve Açıklama Giriniz','error')
			}else {
				handleClose()
			}
			
		}
		if (approvalModal.invoiceStatusId == 5) {
			dispatch(updateEdittedRow({ key: 'invoiceStatusId', value: approvalModal.invoiceStatusId }))
			dispatch(updateEdittedRow({ key: 'responsibleRole', value: 'AM' }))
			handleClose()
		}
	}
	const handleChange = (value, name) => {
		dispatch(updateEdittedRow({ key: name, value: value }))
	}
	const handleDelete = async (deleteData, index) => {
		deleteFile('/Invoices/DeleteInvoiceDocuments', {
			method: 'DELETE',
			data: deleteData
		}).then(res => {
			if (res.data.ok) {
				dispatch(updateEdittedRow({ key: 'invoicesDocuments', value: [...edittedRow['invoicesDocuments'].filter((f, i) => i != index)] }))
			}
		})
	}
	return (
		<div className='w-100 d-flex flex-column gap-3 approval-modal-content'>
			<div className='row text-center'>
				<div className='col-12'>{approvalModal?.text}</div>
			</div>
			{
				approvalModal?.invoiceStatusId == 7 && <>
				<div className="row justify-content-center">
					<div className="col-md-12 col-xl-11">
						<div className='form-control'>
							<input className='default-input' placeholder='Fatura Numarası' value={edittedRow?.invoiceNo} name='invoiceNo' type='text' onChange={(e) => handleChange(e.target.value, 'invoiceNo')} />
						</div>
					</div>
				</div>
			</> 
			}
			
			{(approvalModal?.invoiceStatusId == 2 || approvalModal?.invoiceStatusId == 7) && (
				<div className='row justify-content-center'>
					<div className='col-md-12 col-xl-11'>

						<label className='project-file-upload--form--row--item--file-uploader--label' htmlFor='file-uploader'>
							<span className='project-file-upload--form--row--item--file-uploader--label--text'>
								<Icons.plus /> Dosya Ekle
							</span>
						</label>
						<input
							type='file'
							// accept="image/*,video/*"
							multiple
							onChange={(e) => convert(e.target.files)}
							id='file-uploader'
							className='project-file-upload--form--row--item--file-uploader--input'
						/>
						{edittedRow?.invoicesDocuments?.length > 0 && (
							edittedRow?.invoicesDocuments?.map((file, i) => (
								<div className='text-sm comment-fileList w-unset' key={i}>
									<div className='d-flex align-items-center'>{file?.fileName}</div>
									<Icons.delete
										onClick={() => {
											handleDelete(file, i)
										}}
										size={16}
									/>
								</div>
							))
						)}
					</div>
				</div>
			)}
			{
				(approvalModal.invoiceStatusId == 2 || approvalModal.invoiceStatusId == 7) && (
					<div className="row justify-content-center">
				<div className="col-md-12 col-xl-11">
					<div className='form-control'>
						<label htmlFor="" className="form-control-label">
							Açıklama
						</label>
						<input className='default-input' placeholder='Açıklama' value={edittedRow?.description} name='description' type='text' onChange={(e) => handleChange(e.target.value, 'description')} />
					</div>
				</div>
				</div>
				)
			}
			{
				approvalModal?.invoiceStatusId == 2 && <div className="row justify-content-center">
					<div className="col-md-12 col-xl-11">
						<div className="form-control">
							<label className="form-control-label">
								Kesilecek Ay
							</label>
							<Calendar
								className='w-100'
								view="month" 
								dateFormat="mm/yy"
								placeholder='Kesilecek Ay/Yıl'
								value={edittedRow['estimatedDate'] && moment(edittedRow['estimatedDate']).locale('en')._d}
								name='estimatedDate'
								onChange={(e) => {
									handleChange(moment(e.target.value).add(3, 'hours').toISOString(),'estimatedDate')
								}}
							/>
						</div>
					</div>
				</div>
			}
			<div className='row justify-content-center gap-3'>
				<Button handleClick={handleApproved} className='btn-success' title={approvalModal.invoiceStatusId == 2 ? 'Kaydet' : 'Onayla'} />
				<Button
					handleClick={() => {
						if (approvalModal?.invoiceStatusId == 2 && !edittedRow['estimatedDate']) {
							showToast('Kesilecek Ay/Yıl seçimini yapınız','error')
						}else {
							handleClose()
						}
					}}
					className='btn-danger-outline'
					title={approvalModal?.invoiceStatusId == 2 ? 'Dosya Eklemek İstemiyorum' : 'Vazgeç'}
				/>
			</div>
		</div>
	)
}
InvoiceInlineApprovalModalContent.propTypes = {
	handleClose: PropTypes.func,
	approvalModal: PropTypes.object,
}
export default InvoiceInlineApprovalModalContent
